import O1HD from "../../gameEngine";
import { GAME_MODE } from "../../managers/gameContent/gameMode_json";
import { PAGE, UI_Z_INDEX } from "../uiModule";
import { IPagePramsBase } from "./UIPrams";
export default class PageBase extends cc.Component{
    public pageIndex : UI_Z_INDEX;
    public pageName : string;
    protected m_mode : GAME_MODE = GAME_MODE.NORMAL;
    protected registed : boolean = false;
    protected content:cc.Node = null;
    protected btnRoot:cc.Node = null;
    protected topRoot : cc.Node = null;
    protected onClose : Function = null;
    protected onReward : Function = null;

    public dialogIndex : number = 0;

    protected m_prams : IPagePramsBase = null;

    protected managers(){
        return O1HD.getManagers();
    }
    protected services(){
        return O1HD.getServices();
    }
    protected modules(){
        return O1HD.getModules();
    }

    protected useAnim : boolean = true;

    async OnPageOpen(prams?:IPagePramsBase){
        if(prams){
            this.m_prams = prams;
            this.m_mode = prams.mode;
            this.onClose = prams.onClose;
            this.onReward = prams.onReward;
        }else{
            this.m_mode = this.m_prams?.mode;
            this.onClose = this.m_prams?.onClose;
            this.onReward = this.m_prams?.onReward;
        }
        
        if(!this.registed){
            // console.warn("????sjnfmwklaj")
            this.AddEvent();
        }
        this.btnRoot = this.node.getChildByName("ButtonRoot");
        this.topRoot = this.node.getChildByName("TopRoot");
        this.content = this.node.getChildByName("Content");
        
        this.node.active = true;
        if(this.useAnim){
            this.node.opacity = 0;
            this.btnRoot && this.btnRoot.children.forEach((node)=>{
                node.opacity = 0;
            });
            if(this.content){
                this.content.scale = 0;
            }
            this.Log("打开",this.dialogIndex);
            cc.tween(this.node).to(0.25,{opacity:255}).start();
            if(this.content){
                await new Promise<void>((resolve)=>{
                    cc.tween(this.content).delay(0.2).call(()=>{
                        // O1HD.getManagers().soundMgr.playSound("tanchuang");
                        
                    }).to(0.3,{scale:1},{easing:'backOut'}).call(resolve).start();
                });
            }
            if(this.btnRoot){
                for (let index = 0; index < this.btnRoot.children.length; index++) {
                    const element = this.btnRoot.children[index];
                    // await new Promise<void>((resolve, reject) => {
                        cc.tween(element).to(0.1,{opacity:255})
                        // .call(resolve)
                        .start();
                    // });
                }
            }
        }else{
            this.node.opacity = 255;
        }
    }

    HidePage(){
        cc.tween(this.node).to(0.1,{opacity:0}).call(()=>{
            this.node.active = false;
        }).start();
    }

    ClosePage(){
        const realName : string = (this.pageIndex == UI_Z_INDEX.DIALOG)?this.pageName+this.dialogIndex.toString():this.pageName;
        this.modules().uiControlModule.ClosePage(realName);
    }
    
    OnPageClose(){
        this.RemoveEvent();
        this.Log("关闭页面",this.dialogIndex);
        this.onClose && this.onClose();
        this.onClose = null;
        this.onReward = null;
        if(this.node.isValid){
            cc.tween(this.node).to(0.1,{opacity:0}).call(()=>{
                this.node.destroy();
            }).start();
        }
    }

    async BackMain(){
        await O1HD.getManagers().gameMgr.returnMainScene();
        // this.onClose && this.onClose();
        this.modules().uiControlModule.CloseAllPage();
    }

    async OnMainBtn(){
        this.managers().soundMgr.playSound('anNiu');

        this.BackMain();
        
        // mainRoot.UISystem.OpenPage(PAGE.LEVELMENU,{
        //     mode:this.m_mode
        // });
    }
    
    OnCloseBtn(){
        this.managers().soundMgr.playSound('anNiu');
        this.ClosePage();
    }

    AddEvent(){
        this.registed = true;
        this.Log("注册事件");
    }
    RemoveEvent(){
        this.Log("注销事件");
        this.registed = false;
    }

    protected Log(...prams){
        console.log(`${this.pageName}:--->>[\n`,...prams,"\n]");
    }
    protected Warn(...prams){
        console.warn(`${this.pageName}:---[\n`,...prams,"\n]");
    }

    onDestroy(){

    }
}